import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
} from '../../UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../UUID.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  FloatSerializer_getInstance2fspe61zbqree as FloatSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../lightningdb/HasId.mjs';
import { Companion_getInstance3i96z74mcv2y1 as Companion_getInstance_1 } from '../serverhealth/HealthStatus.mjs';
import { LocalDateIso8601Serializer_getInstanceny1y5h6nyej8 as LocalDateIso8601Serializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function FunnelInstance$Companion$$childSerializers$_anonymous__ik9a9t() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function FunnelInstance$Companion$$childSerializers$_anonymous__ik9a9t_0() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, FunnelInstance$Companion$$childSerializers$_anonymous__ik9a9t);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s39_1 = [tmp_1, null, null, null, null, lazy(tmp_2, FunnelInstance$Companion$$childSerializers$_anonymous__ik9a9t_0), null, null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.monitoring.FunnelInstance', this, 11);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('funnel', false);
        tmp0_serialDesc.c1b('userAgent', false);
        tmp0_serialDesc.c1b('user', true);
        tmp0_serialDesc.c1b('version', false);
        tmp0_serialDesc.c1b('errors', true);
        tmp0_serialDesc.c1b('step', true);
        tmp0_serialDesc.c1b('success', true);
        tmp0_serialDesc.c1b('started', true);
        tmp0_serialDesc.c1b('expiry', true);
        tmp0_serialDesc.c1b('expectedErrorRate', true);
        this.f4n_1 = tmp0_serialDesc;
      }
      g4n(encoder, value) {
        var tmp0_desc = this.f4n_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().s39_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.z39_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.z39_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.a3a_1);
        tmp1_output.a15(tmp0_desc, 2, value.b3a_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.c3a_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.c3a_1);
        }
        tmp1_output.a15(tmp0_desc, 4, value.d3a_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.e3a_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.e3a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.f3a_1 === 0)) {
          tmp1_output.v14(tmp0_desc, 6, value.f3a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.g3a_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), value.g3a_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance).d1m();
          tmp_0 = !value.h3a_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), value.h3a_1);
        }
        var tmp_1;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp_1 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp_2 = get_default(Companion_instance).d1m();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$3 = toDuration(20, DurationUnit_MINUTES_getInstance());
          tmp_1 = !value.i3a_1.equals(tmp_2.u26(tmp$ret$3));
        }
        if (tmp_1) {
          tmp1_output.c15(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), value.i3a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !equals(value.j3a_1, 0.05)) {
          tmp1_output.x14(tmp0_desc, 10, value.j3a_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4n(encoder, value instanceof FunnelInstance() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4n_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = 0;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = 0.0;
        var tmp15_input = decoder.l13(tmp0_desc);
        var tmp16_cached = Companion_getInstance_2().s39_1;
        if (tmp15_input.a14()) {
          tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.x13(tmp0_desc, 5, tmp16_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp15_input.q13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.x13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.s13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.x13(tmp0_desc, 5, tmp16_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp15_input.q13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.x13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.s13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp15_input.m13(tmp0_desc);
        return FunnelInstance().h4n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.f4n_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_2().s39_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[5].f2(), IntSerializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), InstantIso8601Serializer_getInstance(), InstantIso8601Serializer_getInstance(), FloatSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var FunnelInstanceClass;
function FunnelInstance() {
  if (FunnelInstanceClass === VOID) {
    class $ {
      constructor(_id, funnel, userAgent, user, version, errors, step, success, started, expiry, expectedErrorRate) {
        Companion_getInstance_2();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        user = user === VOID ? null : user;
        var tmp;
        if (errors === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = errors;
        }
        errors = tmp;
        step = step === VOID ? 0 : step;
        success = success === VOID ? null : success;
        var tmp_0;
        if (started === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).d1m();
        } else {
          tmp_0 = started;
        }
        started = tmp_0;
        var tmp_1;
        if (expiry === VOID) {
          // Inline function 'com.lightningkite.now' call
          var tmp_2 = get_default(Companion_instance).d1m();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$1 = toDuration(20, DurationUnit_MINUTES_getInstance());
          tmp_1 = tmp_2.u26(tmp$ret$1);
        } else {
          tmp_1 = expiry;
        }
        expiry = tmp_1;
        expectedErrorRate = expectedErrorRate === VOID ? 0.05 : expectedErrorRate;
        this.z39_1 = _id;
        this.a3a_1 = funnel;
        this.b3a_1 = userAgent;
        this.c3a_1 = user;
        this.d3a_1 = version;
        this.e3a_1 = errors;
        this.f3a_1 = step;
        this.g3a_1 = success;
        this.h3a_1 = started;
        this.i3a_1 = expiry;
        this.j3a_1 = expectedErrorRate;
      }
      h40() {
        return this.z39_1;
      }
      i4n(_id, funnel, userAgent, user, version, errors, step, success, started, expiry, expectedErrorRate) {
        return new (FunnelInstance())(_id, funnel, userAgent, user, version, errors, step, success, started, expiry, expectedErrorRate);
      }
      l3a(_id, funnel, userAgent, user, version, errors, step, success, started, expiry, expectedErrorRate, $super) {
        _id = _id === VOID ? this.z39_1 : _id;
        funnel = funnel === VOID ? this.a3a_1 : funnel;
        userAgent = userAgent === VOID ? this.b3a_1 : userAgent;
        user = user === VOID ? this.c3a_1 : user;
        version = version === VOID ? this.d3a_1 : version;
        errors = errors === VOID ? this.e3a_1 : errors;
        step = step === VOID ? this.f3a_1 : step;
        success = success === VOID ? this.g3a_1 : success;
        started = started === VOID ? this.h3a_1 : started;
        expiry = expiry === VOID ? this.i3a_1 : expiry;
        expectedErrorRate = expectedErrorRate === VOID ? this.j3a_1 : expectedErrorRate;
        return $super === VOID ? this.i4n(_id, funnel, userAgent, user, version, errors, step, success, started, expiry, expectedErrorRate) : $super.i4n.call(this, _id, funnel, userAgent, user, version, errors, step, success, started, expiry, expectedErrorRate);
      }
      toString() {
        return 'FunnelInstance(_id=' + this.z39_1.toString() + ', funnel=' + this.a3a_1 + ', userAgent=' + this.b3a_1 + ', user=' + this.c3a_1 + ', version=' + this.d3a_1 + ', errors=' + toString(this.e3a_1) + ', step=' + this.f3a_1 + ', success=' + toString_0(this.g3a_1) + ', started=' + this.h3a_1.toString() + ', expiry=' + this.i3a_1.toString() + ', expectedErrorRate=' + this.j3a_1 + ')';
      }
      hashCode() {
        var result = this.z39_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.a3a_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b3a_1) | 0;
        result = imul(result, 31) + (this.c3a_1 == null ? 0 : getStringHashCode(this.c3a_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.d3a_1) | 0;
        result = imul(result, 31) + hashCode(this.e3a_1) | 0;
        result = imul(result, 31) + this.f3a_1 | 0;
        result = imul(result, 31) + (this.g3a_1 == null ? 0 : this.g3a_1.hashCode()) | 0;
        result = imul(result, 31) + this.h3a_1.hashCode() | 0;
        result = imul(result, 31) + this.i3a_1.hashCode() | 0;
        result = imul(result, 31) + getNumberHashCode(this.j3a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FunnelInstance()))
          return false;
        if (!this.z39_1.equals(other.z39_1))
          return false;
        if (!(this.a3a_1 === other.a3a_1))
          return false;
        if (!(this.b3a_1 === other.b3a_1))
          return false;
        if (!(this.c3a_1 == other.c3a_1))
          return false;
        if (!(this.d3a_1 === other.d3a_1))
          return false;
        if (!equals(this.e3a_1, other.e3a_1))
          return false;
        if (!(this.f3a_1 === other.f3a_1))
          return false;
        if (!equals(this.g3a_1, other.g3a_1))
          return false;
        if (!this.h3a_1.equals(other.h3a_1))
          return false;
        if (!this.i3a_1.equals(other.i3a_1))
          return false;
        if (!equals(this.j3a_1, other.j3a_1))
          return false;
        return true;
      }
      static h4n(seen0, _id, funnel, userAgent, user, version, errors, step, success, started, expiry, expectedErrorRate, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(22 === (22 & seen0))) {
          throwMissingFieldException(seen0, 22, $serializer_getInstance().f4n_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.z39_1 = Companion_getInstance().m2p();
        else
          $this.z39_1 = _id;
        $this.a3a_1 = funnel;
        $this.b3a_1 = userAgent;
        if (0 === (seen0 & 8))
          $this.c3a_1 = null;
        else
          $this.c3a_1 = user;
        $this.d3a_1 = version;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.e3a_1 = emptySet();
        } else
          $this.e3a_1 = errors;
        if (0 === (seen0 & 64))
          $this.f3a_1 = 0;
        else
          $this.f3a_1 = step;
        if (0 === (seen0 & 128))
          $this.g3a_1 = null;
        else
          $this.g3a_1 = success;
        if (0 === (seen0 & 256)) {
          var tmp_0 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_0.h3a_1 = get_default(Companion_instance).d1m();
        } else
          $this.h3a_1 = started;
        if (0 === (seen0 & 512)) {
          var tmp_1 = $this;
          // Inline function 'com.lightningkite.now' call
          var tmp_2 = get_default(Companion_instance).d1m();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$3 = toDuration(20, DurationUnit_MINUTES_getInstance());
          tmp_1.i3a_1 = tmp_2.u26(tmp$ret$3);
        } else
          $this.i3a_1 = expiry;
        if (0 === (seen0 & 1024))
          $this.j3a_1 = 0.05;
        else
          $this.j3a_1 = expectedErrorRate;
        return $this;
      }
    }
    initMetadataForClass($, 'FunnelInstance', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance});
    FunnelInstanceClass = $;
  }
  return FunnelInstanceClass;
}
function FunnelSummary$Companion$$childSerializers$_anonymous__s7x6xm() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function FunnelSummary$Companion$$childSerializers$_anonymous__s7x6xm_0() {
  return Companion_getInstance_1().m2a();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, FunnelSummary$Companion$$childSerializers$_anonymous__s7x6xm);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l3c_1 = [tmp_1, null, null, lazy(tmp_2, FunnelSummary$Companion$$childSerializers$_anonymous__s7x6xm_0), null, null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.monitoring.FunnelSummary', this, 9);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('funnel', false);
        tmp0_serialDesc.c1b('date', false);
        tmp0_serialDesc.c1b('status', false);
        tmp0_serialDesc.c1b('success', true);
        tmp0_serialDesc.c1b('successAfterError', true);
        tmp0_serialDesc.c1b('error', true);
        tmp0_serialDesc.c1b('abandoned', true);
        tmp0_serialDesc.c1b('count', true);
        this.j4n_1 = tmp0_serialDesc;
      }
      k4n(encoder, value) {
        var tmp0_desc = this.j4n_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().l3c_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.s3c_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.s3c_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.t3c_1);
        tmp1_output.c15(tmp0_desc, 2, LocalDateIso8601Serializer_getInstance(), value.u3c_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.v3c_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.w3c_1, 0.0)) {
          tmp1_output.x14(tmp0_desc, 4, value.w3c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !equals(value.x3c_1, 0.0)) {
          tmp1_output.x14(tmp0_desc, 5, value.x3c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !equals(value.y3c_1, 0.0)) {
          tmp1_output.x14(tmp0_desc, 6, value.y3c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !equals(value.z3c_1, 0.0)) {
          tmp1_output.x14(tmp0_desc, 7, value.z3c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.a3d_1 === 0)) {
          tmp1_output.v14(tmp0_desc, 8, value.a3d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k4n(encoder, value instanceof FunnelSummary() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.j4n_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0.0;
        var tmp9_local5 = 0.0;
        var tmp10_local6 = 0.0;
        var tmp11_local7 = 0.0;
        var tmp12_local8 = 0;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_3().l3c_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.x13(tmp0_desc, 2, LocalDateIso8601Serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.x13(tmp0_desc, 3, tmp14_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.s13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.s13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.s13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.s13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.q13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.x13(tmp0_desc, 2, LocalDateIso8601Serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.x13(tmp0_desc, 3, tmp14_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.s13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.s13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.s13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.s13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.q13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return FunnelSummary().l4n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.j4n_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_3().l3c_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), LocalDateIso8601Serializer_getInstance(), tmp0_cached[3].f2(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var FunnelSummaryClass;
function FunnelSummary() {
  if (FunnelSummaryClass === VOID) {
    class $ {
      constructor(_id, funnel, date, status, success, successAfterError, error, abandoned, count) {
        Companion_getInstance_3();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        success = success === VOID ? 0.0 : success;
        successAfterError = successAfterError === VOID ? 0.0 : successAfterError;
        error = error === VOID ? 0.0 : error;
        abandoned = abandoned === VOID ? 0.0 : abandoned;
        count = count === VOID ? 0 : count;
        this.s3c_1 = _id;
        this.t3c_1 = funnel;
        this.u3c_1 = date;
        this.v3c_1 = status;
        this.w3c_1 = success;
        this.x3c_1 = successAfterError;
        this.y3c_1 = error;
        this.z3c_1 = abandoned;
        this.a3d_1 = count;
      }
      h40() {
        return this.s3c_1;
      }
      m4n(_id, funnel, date, status, success, successAfterError, error, abandoned, count) {
        return new (FunnelSummary())(_id, funnel, date, status, success, successAfterError, error, abandoned, count);
      }
      c3d(_id, funnel, date, status, success, successAfterError, error, abandoned, count, $super) {
        _id = _id === VOID ? this.s3c_1 : _id;
        funnel = funnel === VOID ? this.t3c_1 : funnel;
        date = date === VOID ? this.u3c_1 : date;
        status = status === VOID ? this.v3c_1 : status;
        success = success === VOID ? this.w3c_1 : success;
        successAfterError = successAfterError === VOID ? this.x3c_1 : successAfterError;
        error = error === VOID ? this.y3c_1 : error;
        abandoned = abandoned === VOID ? this.z3c_1 : abandoned;
        count = count === VOID ? this.a3d_1 : count;
        return $super === VOID ? this.m4n(_id, funnel, date, status, success, successAfterError, error, abandoned, count) : $super.m4n.call(this, _id, funnel, date, status, success, successAfterError, error, abandoned, count);
      }
      toString() {
        return 'FunnelSummary(_id=' + this.s3c_1.toString() + ', funnel=' + this.t3c_1 + ', date=' + this.u3c_1.toString() + ', status=' + this.v3c_1.toString() + ', success=' + this.w3c_1 + ', successAfterError=' + this.x3c_1 + ', error=' + this.y3c_1 + ', abandoned=' + this.z3c_1 + ', count=' + this.a3d_1 + ')';
      }
      hashCode() {
        var result = this.s3c_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.t3c_1) | 0;
        result = imul(result, 31) + this.u3c_1.hashCode() | 0;
        result = imul(result, 31) + this.v3c_1.hashCode() | 0;
        result = imul(result, 31) + getNumberHashCode(this.w3c_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.x3c_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.y3c_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.z3c_1) | 0;
        result = imul(result, 31) + this.a3d_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FunnelSummary()))
          return false;
        if (!this.s3c_1.equals(other.s3c_1))
          return false;
        if (!(this.t3c_1 === other.t3c_1))
          return false;
        if (!this.u3c_1.equals(other.u3c_1))
          return false;
        if (!this.v3c_1.equals(other.v3c_1))
          return false;
        if (!equals(this.w3c_1, other.w3c_1))
          return false;
        if (!equals(this.x3c_1, other.x3c_1))
          return false;
        if (!equals(this.y3c_1, other.y3c_1))
          return false;
        if (!equals(this.z3c_1, other.z3c_1))
          return false;
        if (!(this.a3d_1 === other.a3d_1))
          return false;
        return true;
      }
      static l4n(seen0, _id, funnel, date, status, success, successAfterError, error, abandoned, count, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_0().j4n_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.s3c_1 = Companion_getInstance().m2p();
        else
          $this.s3c_1 = _id;
        $this.t3c_1 = funnel;
        $this.u3c_1 = date;
        $this.v3c_1 = status;
        if (0 === (seen0 & 16))
          $this.w3c_1 = 0.0;
        else
          $this.w3c_1 = success;
        if (0 === (seen0 & 32))
          $this.x3c_1 = 0.0;
        else
          $this.x3c_1 = successAfterError;
        if (0 === (seen0 & 64))
          $this.y3c_1 = 0.0;
        else
          $this.y3c_1 = error;
        if (0 === (seen0 & 128))
          $this.z3c_1 = 0.0;
        else
          $this.z3c_1 = abandoned;
        if (0 === (seen0 & 256))
          $this.a3d_1 = 0;
        else
          $this.a3d_1 = count;
        return $this;
      }
    }
    initMetadataForClass($, 'FunnelSummary', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_0});
    FunnelSummaryClass = $;
  }
  return FunnelSummaryClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.monitoring.FunnelStart', this, 5);
        tmp0_serialDesc.c1b('funnel', false);
        tmp0_serialDesc.c1b('userAgent', false);
        tmp0_serialDesc.c1b('version', false);
        tmp0_serialDesc.c1b('expireAfterMinutes', true);
        tmp0_serialDesc.c1b('expectedErrorRate', true);
        this.n4n_1 = tmp0_serialDesc;
      }
      o4n(encoder, value) {
        var tmp0_desc = this.n4n_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.p4n_1);
        tmp1_output.a15(tmp0_desc, 1, value.q4n_1);
        tmp1_output.a15(tmp0_desc, 2, value.r4n_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.s4n_1 === 20)) {
          tmp1_output.v14(tmp0_desc, 3, value.s4n_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.t4n_1, 0.05)) {
          tmp1_output.x14(tmp0_desc, 4, value.t4n_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o4n(encoder, value instanceof FunnelStart() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n4n_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = 0;
        var tmp8_local4 = 0.0;
        var tmp9_input = decoder.l13(tmp0_desc);
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.q13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.s13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.q13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.s13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return FunnelStart().u4n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.n4n_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var FunnelStartClass;
function FunnelStart() {
  if (FunnelStartClass === VOID) {
    class $ {
      toString() {
        return 'FunnelStart(funnel=' + this.p4n_1 + ', userAgent=' + this.q4n_1 + ', version=' + this.r4n_1 + ', expireAfterMinutes=' + this.s4n_1 + ', expectedErrorRate=' + this.t4n_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.p4n_1);
        result = imul(result, 31) + getStringHashCode(this.q4n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r4n_1) | 0;
        result = imul(result, 31) + this.s4n_1 | 0;
        result = imul(result, 31) + getNumberHashCode(this.t4n_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FunnelStart()))
          return false;
        if (!(this.p4n_1 === other.p4n_1))
          return false;
        if (!(this.q4n_1 === other.q4n_1))
          return false;
        if (!(this.r4n_1 === other.r4n_1))
          return false;
        if (!(this.s4n_1 === other.s4n_1))
          return false;
        if (!equals(this.t4n_1, other.t4n_1))
          return false;
        return true;
      }
      static u4n(seen0, funnel, userAgent, version, expireAfterMinutes, expectedErrorRate, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_1().n4n_1);
        }
        var $this = createThis(this);
        $this.p4n_1 = funnel;
        $this.q4n_1 = userAgent;
        $this.r4n_1 = version;
        if (0 === (seen0 & 8))
          $this.s4n_1 = 20;
        else
          $this.s4n_1 = expireAfterMinutes;
        if (0 === (seen0 & 16))
          $this.t4n_1 = 0.05;
        else
          $this.t4n_1 = expectedErrorRate;
        return $this;
      }
    }
    initMetadataForClass($, 'FunnelStart', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    FunnelStartClass = $;
  }
  return FunnelStartClass;
}
//region block: init
Companion_instance_2 = new (Companion_1())();
//endregion
//region block: exports
export {
  FunnelInstance as FunnelInstance3u6ziddd47o20,
  FunnelSummary as FunnelSummary2xkqtzvrnqmvn,
  Companion_getInstance_2 as Companion_getInstance1plstrcui6kcy,
  Companion_instance_2 as Companion_instance2jzcizpuuma18,
  Companion_getInstance_3 as Companion_getInstance35jta5xdhkpv2,
};
//endregion

//# sourceMappingURL=models.mjs.map
